import React, { createContext } from "react"

import { SelectOption } from "shared/types/Select"

// Context types use `any` intentionally — context cannot be generic.
/* eslint-disable @typescript-eslint/no-explicit-any */
type AnyOption = SelectOption<any>

export interface ComboboxContextType {
  fieldRef?: React.Ref<HTMLButtonElement>
  hasError?: boolean
  creatable?: boolean
  elevated?: boolean
  value?: AnyOption | AnyOption[] | null
  onValueChange?: (value: AnyOption | AnyOption[] | null) => void
  items?: AnyOption[]
  multiple?: boolean
  disabled?: boolean
}
/* eslint-enable @typescript-eslint/no-explicit-any */

export const ComboboxContext = createContext<ComboboxContextType>({})
